import BaseFileService from "@/modules/core/file/protected/BaseFileService";
import env from "environment";

class CreditAssignmentFileService extends BaseFileService {
  constructor() {
    super({
      baseUrl: env.baseUrl + "/credit-assignments/files"
    });
  }
}

const service = new CreditAssignmentFileService();

export default service;
